// Corsac product page: gallery, form, reviews (Judge.me), complete the look, related, recently viewed, sticky bar.
// The section's Liquid renders the headings and the review markup; CX_DATA.current names the product.
(function () {
  const CX = window.CX;
  const { $, $$, esc, icon, roll } = CX;
  const R = CX.routes;
  const T = CX.productTexts;
  const p = CX.byId((window.CX_DATA || {}).current);
  if (!p || !$('[data-cx-section="product"]')) return;

  /* ---------- Gallery (live layout): two-column photo grid on desktop, peeking slider + thumbnails on phones ---------- */
  // Only the gallery for the current width is filled, so phones never download the desktop grid and vice versa.
  const wideMq = window.matchMedia('(min-width: 900px)');
  const track = $('[data-cx-track]');
  const thumbs = $('[data-cx-thumbs]');
  const count = $('[data-cx-gcount]');
  const alt = (i) => `${p.name}${p.gallery.length > 1 ? ` (photo ${i + 1} of ${p.gallery.length})` : ''}`;
  let slides = [];
  const at = () => {
    const mid = track.scrollLeft + track.clientWidth / 2;
    let best = 0;
    slides.forEach((f, k) => { if (Math.abs(f.offsetLeft + f.offsetWidth / 2 - mid) < Math.abs(slides[best].offsetLeft + slides[best].offsetWidth / 2 - mid)) best = k; });
    return best;
  };
  const go = (i) => { const f = slides[Math.max(0, Math.min(slides.length - 1, i))]; if (f) track.scrollTo({ left: f.offsetLeft - (track.clientWidth - f.offsetWidth) / 2, behavior: 'smooth' }); };
  const sync = () => {
    if (!slides.length) return;
    const i = at();
    count.textContent = p.gallery.length > 1 ? `${i + 1} / ${p.gallery.length}` : '';
    $$('button', thumbs).forEach((b, k) => { b.classList.toggle('is-on', k === i); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    $('[data-cx-gprev]').disabled = i === 0;
    $('[data-cx-gnext]').disabled = i >= p.gallery.length - 1;
  };
  const fill = () => {
    if (wideMq.matches) {
      $('[data-cx-pgrid]').innerHTML = p.gallery.map((u, i) => `<figure data-cx-unveil style="--d:${(i % 2) * 80}ms">${CX.pic(u, { alt: alt(i), sizes: '(min-width: 1200px) 31vw, 33vw', w: 1000, lazy: i > 1, high: i === 0 })}</figure>`).join('');
      if (CX.observe) CX.observe($('[data-cx-pgrid]'));
    } else if (!slides.length) {
      track.innerHTML = p.gallery.map((u, i) => `<figure>${CX.pic(u, { alt: alt(i), sizes: 'calc(100vw - 56px)', w: 900, lazy: i > 0, high: i === 0 })}</figure>`).join('');
      thumbs.innerHTML = p.gallery.length > 1 ? p.gallery.map((u, i) => `<button aria-label="Show photo ${i + 1}">${CX.pic(u, { w: 200, sizes: '56px' })}</button>`).join('') : '';
      slides = $$('figure', track);
      $$('button', thumbs).forEach((b, i) => b.addEventListener('click', () => go(i)));
      sync();
    }
  };
  $('[data-cx-gprev]').addEventListener('click', () => go(at() - 1));
  $('[data-cx-gnext]').addEventListener('click', () => go(at() + 1));
  track.addEventListener('scroll', sync, { passive: true });
  wideMq.addEventListener('change', fill);
  fill();
  if (p.gallery.length < 2) $$('.cx-pp__arrow').forEach((b) => b.remove());

  /* ---------- Form ---------- */
  $('[data-cx-form]').innerHTML = CX.pform(p, true);
  const form = $('[data-cx-pform]');
  // The details panel sticks beside the photos. A panel taller than the screen moves with the page: scrolling down
  // it settles by its bottom edge, scrolling up it settles by its top edge, always below the header when the header
  // is showing, so the title never hides behind it.
  const info = $('[data-cx-form]');
  const header = $('[data-cx-header]');
  let offset = null;
  let lastY = window.scrollY;
  const place = () => {
    if (!wideMq.matches) { info.style.top = ''; offset = null; return; }
    const headH = header && !header.classList.contains('is-hidden') ? header.offsetHeight : 0;
    const maxTop = headH + 20;
    const minTop = Math.min(maxTop, window.innerHeight - info.offsetHeight - 20);
    const y = window.scrollY;
    if (offset === null) offset = maxTop;
    offset = Math.max(minTop, Math.min(maxTop, offset - (y - lastY)));
    lastY = y;
    info.style.top = `${Math.round(offset)}px`;
  };
  let placing = false;
  window.addEventListener('scroll', () => { if (!placing) { placing = true; requestAnimationFrame(() => { placing = false; place(); }); } }, { passive: true });
  window.addEventListener('resize', place);
  if ('ResizeObserver' in window) new ResizeObserver(place).observe(info);
  // When the header slides in or out, the panel eases to its new top in step with it.
  let ease;
  if (header) new MutationObserver(() => {
    info.style.transition = 'top 0.5s cubic-bezier(0.22, 0.61, 0.21, 1)';
    place();
    clearTimeout(ease);
    ease = setTimeout(() => { info.style.transition = ''; }, 520);
  }).observe(header, { attributes: true, attributeFilter: ['class'] });

  /* ---------- Reviews: Judge.me's widget when its app embed runs; otherwise the reviews it rendered, drawn by us;
     with no reviews, an invite and a native form that sends the review to the store's email ---------- */
  const box = $('[data-cx-review-empty]');
  if (box) {
    const widget = $('.jdgm-widget');
    const fields = $('[data-cx-review-fields]', box);
    const open = $('[data-cx-review-open]', box);
    const copy = $('[data-cx-review-copy]', box);
    const list = $('[data-cx-review-list]');
    if (open && fields) open.addEventListener('click', () => { fields.hidden = !fields.hidden; open.setAttribute('aria-expanded', String(!fields.hidden)); });
    const drawStatic = () => {
      const revs = widget ? $$('.jdgm-rev', widget) : [];
      if (!list || !revs.length) return false;
      const wrap = $('.jdgm-rev-widg', widget);
      const avg = parseFloat(wrap && wrap.dataset.averageRating) || 0;
      const total = parseInt(wrap && wrap.dataset.numberOfReviews, 10) || revs.length;
      list.innerHTML = `<div class="cx-review-sum"><b>${avg.toFixed(1)}</b><span class="cx-stars" style="--r:${avg}"><i></i></span><span>Based on ${total} review${total === 1 ? '' : 's'}</span></div>` + revs.map((r) => {
        const q = (sel) => r.querySelector(sel);
        const score = parseFloat((q('.jdgm-rev__rating') || { dataset: {} }).dataset.score) || 0;
        const author = ((q('.jdgm-rev__author') || {}).textContent || '').trim();
        const time = (q('.jdgm-rev__timestamp') || {}).dateTime;
        const date = time ? new Date(time).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
        const title = ((q('.jdgm-rev__title') || {}).textContent || '').trim();
        const body = ((q('.jdgm-rev__body') || {}).textContent || '').trim();
        const verified = r.dataset.verifiedBuyer === 'true';
        return `<article class="cx-review"><div class="cx-review__top"><span class="cx-review__avatar">${esc(author.charAt(0).toUpperCase())}</span><div><p class="cx-review__name">${esc(author)}${verified ? ' <em>Verified buyer</em>' : ''}</p><span class="cx-stars cx-stars--sm" style="--r:${score}"><i></i></span></div>${date ? `<time>${date}</time>` : ''}</div>${title ? `<h3>${esc(title)}</h3>` : ''}${body ? `<p>${esc(body)}</p>` : ''}</article>`;
      }).join('');
      list.hidden = false;
      widget.hidden = true;
      if (copy) copy.hidden = true;
      box.classList.add('is-compact');
      box.hidden = false;
      return true;
    };
    const settle = () => $$('[data-cx-review-skel]').forEach((k) => k.remove());
    const judgemeReady = () => widget && widget.classList.contains('jdgm--done-setup-widget') && widget.querySelector('.jdgm-rev-widg');
    const formReady = () => !!(window.jdgm && window.jdgm.$ && typeof window.jdgm.$.validator === 'function' && document.querySelector('.jdgm-write-review-modal'));
    const modalOpen = () => { const m = document.querySelector('.jdgm-write-review-modal'); return !!(m && getComputedStyle(m).display !== 'none' && m.offsetHeight > 0); };
    const showNative = () => { if (!fields) return; box.hidden = false; fields.hidden = false; if (open) open.hidden = true; if (copy) copy.hidden = true; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
    // Judge.me only prefetches its review-form script; load it the way its own loader does so its button works.
    let formAsked = false;
    const ensureForm = () => {
      const jm = window.jdgm;
      if (formAsked || !jm || !jm.loadScript || !jm.$ || !jm.CDN_HOST) return;
      formAsked = true;
      if (typeof jm.$.validator === 'function') return;
      jm.loadScript(jm.CDN_HOST + 'widget/form.js');
      if (jm.loadCSS && jm.widgetPath) jm.loadCSS(jm.widgetPath('form.css'));
    };
    // If "Write a review" is clicked before Judge.me's form has loaded, wait and click again; if it never opens, show ours.
    let wired = false;
    let waiting = false;
    const wireWrite = () => {
      if (wired || !widget) return;
      wired = true;
      widget.addEventListener('click', (e) => {
        const link = e.target.closest('.jdgm-write-rev-link');
        if (!link || waiting || e.isTrusted === false) return;
        setTimeout(() => {
          if (modalOpen()) return;
          if (formReady()) { showNative(); return; }
          ensureForm();
          waiting = true;
          const t0 = Date.now();
          const poll = () => {
            if (formReady()) { waiting = false; setTimeout(() => { if (!modalOpen()) link.click(); }, 50); setTimeout(() => { if (!modalOpen()) showNative(); }, 900); }
            else if (Date.now() - t0 > 6000) { waiting = false; showNative(); } else setTimeout(poll, 150);
          };
          poll();
        }, 500);
      });
    };
    const showJudgeme = () => {
      wireWrite();
      widget.hidden = false;
      widget.style.cssText = '';
      $$('.jdgm-temp-hiding-style', widget).forEach((st) => st.remove());
      if (list) list.hidden = true;
      box.hidden = true;
      settle();
    };
    const jdgmScript = () => document.querySelector('script[src*="judgeme"], script[src*="judge.me"]');
    const run = () => {
      const started = Date.now();
      const tick = () => {
        ensureForm();
        const waited = Date.now() - started;
        if (judgemeReady() && (formReady() || waited > 6000)) return showJudgeme();
        const absent = !jdgmScript() && !window.jdgmSettings;
        if (waited > 8000 || (absent && waited > 3000)) { if (!drawStatic()) box.hidden = false; settle(); return; }
        setTimeout(tick, 250);
      };
      tick();
    };
    if (document.readyState === 'complete') run(); else window.addEventListener('load', run, { once: true });
  }

  /* ---------- Complete the look ---------- */
  const pairs = CX.pairsFor(p);
  const bundle = $('[data-cx-section="bundle"]');
  if (bundle && pairs.length && p.inStock) {
    const items = [p, ...pairs];
    const options = (q, pick) => `<option value="">Size</option>${q.sizes.map((s) => `<option value="${esc(s)}"${s === pick ? ' selected' : ''}${CX.isSold(q, s) ? ' disabled' : ''}>${esc(s)}${CX.isSold(q, s) ? ' (sold out)' : ''}</option>`).join('')}`;
    $('[data-cx-bundle-items]').innerHTML = items.map((q, i) => `
      ${i ? `<span class="cx-bundle__plus" aria-hidden="true">${icon('plus', 'cx-icon--sm')}</span>` : ''}
      <div class="cx-bitem is-on" data-id="${esc(q.id)}">
        <button class="cx-bitem__check" aria-pressed="true" aria-label="Include ${esc(q.name)}">${icon('check', 'cx-icon--sm')}</button>
        <a class="cx-bitem__img" href="${R.product(q.id)}">${CX.pic(q.gallery[0], { w: 400, sizes: '160px', alt: q.name })}</a>
        <div class="cx-bitem__info">
          ${i ? '' : '<span class="cx-badge">This item</span>'}
          <a class="cx-bitem__name" href="${R.product(q.id)}">${esc(q.name)}</a>
          ${CX.price(q)}
          ${q.sizes.length ? `<label class="cx-select"><span class="cx-sr">Size for ${esc(q.name)}</span><select data-cx-bsize>${options(q, i ? '' : CX.formSize(form))}</select></label>` : ''}
        </div>
      </div>`).join('');
    const update = () => {
      const on = $$('.cx-bitem.is-on', bundle).map((el) => CX.byId(el.dataset.id));
      const total = on.reduce((n, q) => n + q.price, 0);
      const saved = on.reduce((n, q) => n + (q.compare ? q.compare - q.price : 0), 0);
      $('[data-cx-bundle-count]').textContent = `Total for ${on.length} ${on.length === 1 ? 'item' : 'items'}`;
      $('[data-cx-bundle-total]').textContent = CX.money(total);
      $('[data-cx-bundle-save]').textContent = saved ? `Includes ${CX.money(saved)} off sale prices` : '';
      const add = $('[data-cx-bundle-add]');
      add.disabled = !on.length;
      add.innerHTML = roll(on.length ? `Add ${on.length} to cart` : 'Select an item');
    };
    bundle.addEventListener('click', (e) => {
      const check = e.target.closest('.cx-bitem__check');
      if (check) {
        const item = check.closest('.cx-bitem');
        item.classList.toggle('is-on');
        check.setAttribute('aria-pressed', item.classList.contains('is-on'));
        update();
      }
      if (e.target.closest('[data-cx-bundle-add]')) {
        const missing = $$('.cx-bitem.is-on [data-cx-bsize]', bundle).filter((s) => !s.value);
        $$('[data-cx-bsize]', bundle).forEach((s) => s.parentElement.classList.toggle('is-error', missing.includes(s)));
        if (missing.length) { missing[0].focus(); return; }
        // The cart queues requests, so each piece is added in turn.
        Promise.all($$('.cx-bitem.is-on', bundle).map((el) => {
          const s = $('[data-cx-bsize]', el);
          return CX.cart.add(el.dataset.id, s ? s.value : '', 1);
        })).then(() => CX.open('cart'));
      }
    });
    bundle.addEventListener('change', (e) => {
      if (!e.target.matches('[data-cx-bsize]')) return;
      e.target.parentElement.classList.remove('is-error');
      if (e.target.closest('.cx-bitem').dataset.id === p.id && e.target.value) CX.pickSize(form, e.target.value);
    });
    bundle.hidden = false;
    update();
  }

  /* ---------- You may also like / Recently viewed ---------- */
  const related = $('[data-cx-related]');
  const fillRelated = () => {
    if (!related) return;
    related.innerHTML = CX.relatedFor(p, Number(T.relatedCount) || 8).map((q, i) => CX.card(q, { delay: Math.min(i, 4) * 60 })).join('');
    if (CX.observe) CX.observe(related);
  };
  fillRelated();
  // Related picks get better once the whole catalogue has loaded.
  document.addEventListener('cx:catalogue', fillRelated, { once: true });

  const KEY = 'cx-recent';
  let recent = [];
  try { recent = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { /* storage blocked */ }
  const seen = recent.filter((x) => x !== p.id && CX.byId(x));
  // Recently viewed products may not be in this page's data yet; show them once the catalogue arrives.
  if (recent.some((x) => x !== p.id && !CX.byId(x))) document.addEventListener('cx:catalogue', () => {
    const more = recent.filter((x) => x !== p.id && CX.byId(x));
    if (rs && more.length) { $('[data-cx-recent]').innerHTML = more.slice(0, 10).map((x) => CX.card(CX.byId(x), { reveal: false })).join(''); rs.hidden = false; }
  }, { once: true });
  try { localStorage.setItem(KEY, JSON.stringify([p.id, ...seen].slice(0, 12))); } catch (e) { /* storage blocked */ }
  const rs = $('[data-cx-section="recent"]');
  if (rs && seen.length) {
    const clear = $('[data-cx-recent-clear]');
    $('[data-cx-recent]').innerHTML = seen.slice(0, 10).map((x) => CX.card(CX.byId(x), { reveal: false })).join('');
    rs.hidden = false;
    clear.addEventListener('click', () => {
      try { localStorage.setItem(KEY, JSON.stringify([p.id])); } catch (e) { /* storage blocked */ }
      rs.hidden = true;
    });
  }

  /* ---------- Sticky add bar: shows once the form's own button is off screen ---------- */
  const bar = $('[data-cx-buybar]');
  const addBtn = $('[data-cx-addform]', form);
  if (!bar || !addBtn) return;
  $('[data-cx-bb-img]', bar).src = CX.img(p.gallery[0], 200);
  $('[data-cx-bb-name]', bar).textContent = p.name;
  $('[data-cx-bb-price]', bar).innerHTML = CX.price(p);
  // Top bar: the sizes as tap buttons; bottom bar: a size dropdown.
  const bsizes = $('[data-cx-bb-sizes]', bar);
  if (bsizes) {
    const paint = () => { const cur = CX.formSize(form); $$('button', bsizes).forEach((b) => b.classList.toggle('is-on', b.dataset.size === cur)); };
    if (p.sizes.length) bsizes.innerHTML = p.sizes.map((x) => `<button type="button" class="cx-size" data-size="${esc(x)}"${CX.isSold(p, x) ? ' disabled' : ''}>${esc(x)}</button>`).join('');
    else bsizes.remove();
    bsizes.addEventListener('click', (e) => { const b = e.target.closest('button[data-size]'); if (b && !b.disabled) CX.pickSize(form, b.dataset.size); });
    form.addEventListener('cx:size', paint);
    paint();
  }
  const bsize = $('[data-cx-bb-size]', bar) || document.createElement('select');
  if (!$('[data-cx-bb-size]', bar)) { /* top bar has no dropdown */ } else if (p.sizes.length) bsize.innerHTML = p.sizes.map((s) => `<option value="${esc(s)}"${s === CX.formSize(form) ? ' selected' : ''}${CX.isSold(p, s) ? ' disabled' : ''}>Size ${esc(s)}</option>`).join('');
  else if ($('[data-cx-bb-sizewrap]', bar)) $('[data-cx-bb-sizewrap]', bar).remove();
  bsize.addEventListener('change', () => CX.pickSize(form, bsize.value));
  form.addEventListener('cx:size', (e) => { bsize.value = e.detail; });
  const bb = $('[data-cx-bb-add]', bar);
  bb.innerHTML = roll(p.inStock ? 'Add to cart' : 'Sold out');
  bb.disabled = !p.inStock;
  bb.addEventListener('click', () => addBtn.click());
  let q = false;
  const check = () => {
    q = false;
    const past = addBtn.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-on', past);
    bar.setAttribute('aria-hidden', !past);
  };
  window.addEventListener('scroll', () => { if (!q) { q = true; requestAnimationFrame(check); } }, { passive: true });
})();
